import { createSelector } from "@reduxjs/toolkit";
import Guid from "_shared/guids/guid";
import UserInformation from "users/information/user-information";
import { userNetworkConnectionsApi } from "users/networking/connections/_api/user-network-connection-api";

export const selectNetworkedUserIdSet = createSelector(
  [userNetworkConnectionsApi.endpoints.getUserNetworkConnections.select()],
  (result) => new Set(result.data?.map((u) => u.id) ?? [])
);

export const selectIsNetworkedWith = (otherUserId?: Guid) =>
  createSelector(
    [selectNetworkedUserIdSet], 
    (set) => otherUserId ? set.has(otherUserId.value) : false
  );
  
export const selectNetworkConnectionByUserId = (userId?: Guid) =>
  createSelector(
    [userNetworkConnectionsApi.endpoints.getUserNetworkConnections.select()],
    (result) => {
      if (!userId) return undefined;
      const connectionJson = result.data?.find((connection) => connection.id === userId.value);
      if (!connectionJson) return undefined;
      return UserInformation.fromJSON(connectionJson);
    }
  );
